export const _15_MINUTES_IN_MS = 15 * 1000 * 60
export const _30_MINUTES_IN_MS = 30 * 1000 * 60
/** Шаг опций в списке времени */
export const TIME_SLOT_STEP_MS = _15_MINUTES_IN_MS
/** Дефолтная длительность события (разница «с»–«по») */
export const DEFAULT_DURATION_MS = _30_MINUTES_IN_MS
export const MS_PER_DAY = 24 * 60 * 60 * 1000
export const INITIAL_TIME = -1
/** Потолок «всегда»: без UNTIL бэкенд материализует вхождения до ~2040 */
export const MAX_RECURRENCE_YEARS = 1
